import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../hooks/useAxios";
import { useFeedBack } from "../../../context/FeedBackContext";
import AsyncSelect from 'react-select/async';
import mapValues from "../../../util/mapValues";
import handleLoadSelectOptions from "../../../util/handleLoadSelectOptions";
import useAccountClassifications from "../../../hooks/useAccountClassifications";
import UsersAccountModal from "../../../components/UsersAccountModal";
import update from 'immutability-helper';


const AccountsEdit = () => {

    const { id } = useParams();

    const entity = {
        name: 'Cuentas',
        url: 'accounts',
        frontendUrl: '/cuentas',
        camelName: 'accounts',
    };

    const navigate = useNavigate();

    const [showUsersModal, setShowUsersModal] = useState(false);

    const [data, setData] = useState({
        name: '',
        code: '',
        type: '',
        staff: '',
        description: '',
        accountClassification: '',
        users: []
    });

    const { setLoading, setCustomAlert } = useFeedBack();

    const [{ accountClassifications, total, numberOfPages, loading: loadingAccountClassifications }, getAccountClassifications] = useAccountClassifications({ options: { useCache: false } });

    const [{ data: dataToUpdate, loading: loadingDataToUpdate }, getRecord] = useAxios({ url: `/${entity?.url}/${id}` }, { useCache: false });

    const [{ data: updateData, loading }, updateRecord] = useAxios({ url: `/${entity?.url}/${id}`, method: 'PUT' }, { manual: true, useCache: false });


    useEffect(() => {
        if (dataToUpdate) {
            setData((oldData) => {
                return {
                    ...oldData,
                    ...dataToUpdate?.data,
                    staff: dataToUpdate?.data?.staff ? 'si' : 'no',
                    accountClassification: { label: dataToUpdate?.data?.accountClassification?.name, value: dataToUpdate?.data?.accountClassification?.id }
                }
            });
        }
    }, [dataToUpdate])

    useEffect(() => {
        setLoading({
            show: loading,
            message: 'Actualizando el registro'
        })
    }, [loading]);

    useEffect(() => {
        setLoading({
            show: loadingDataToUpdate,
            message: 'Obteniendo información'
        });
    }, [loadingDataToUpdate]);


    useEffect(() => {
        if (updateData) {
            setCustomAlert({
                show: true,
                severity: 'success',
                title: 'Operación Exitosa',
                message: 'El registro fue actualizado exitosamente.'
            });
            navigate(`${entity?.frontendUrl}/listar`);
        }
    }, [updateData])

    const handleChange = (e) => {
        console.log(e);
        setData((oldData) => {
            return {
                ...oldData,
                [e.target.name]: e.target.value
            }
        });
    }

    const handleSubmit = (e) => {
        e?.preventDefault();

        const { users, accountClassification, ...rest } = data;

        const dataToSend = {
            ...rest,
            accountClassificationId: accountClassification?.value,
            userIds: users?.map(user => user?.id)
        }

        updateRecord({ data: dataToSend });
    }

    const handleRemoveUser = (i) => {
        const newUsersToSet = update(data?.users, { $splice: [[i, 1]] });

        setData((old) => {
            return {
                ...old,
                users: newUsersToSet
            }
        })
    }

    return (
        <div>
            <div className="my-4 align-items-center justify-content-between d-flex">
                <h3>
                    Actualizar {entity?.name}
                </h3>
                {
                    <>
                        <Link to={`${entity?.frontendUrl}/listar`} className="btn btn-primary">
                            Volver al listado
                        </Link>
                    </>
                }
            </div>

            <form className="card p-4" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-8 mb-3">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <div className="form-group">
                                    <label className="text-primary">
                                        Nombre <small className="text-danger">*</small>
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Escriba el nombre..."
                                        className="form-control"
                                        value={data?.name}
                                        name="name"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <div className="form-group">
                                    <label className="text-primary">
                                        Codigo <small className="text-danger">*</small>
                                    </label>
                                    <input
                                        type="number"
                                        placeholder="Codigo..."
                                        className="form-control"
                                        value={data?.code}
                                        name="code"
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <div className="form-group">
                                    <label className="text-primary">
                                        ¿Esta cuenta es afectada por la dotación? <small className="text-danger">*</small>
                                    </label>
                                    <select name="staff" className="form-control" value={data?.staff} onChange={handleChange}>
                                        <option value="" disabled>Seleccione una opción</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <div className="form-group">
                                    <label className="text-primary">
                                        Tipo de cuenta <small className="text-danger">*</small>
                                    </label>
                                    <select name="type" className="form-control" value={data?.type} onChange={handleChange}>
                                        <option value="" disabled>Seleccione una opción</option>
                                        <option value="spent">Gasto</option>
                                        <option value="income">Ingreso</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="form-group">
                                    <label className="text-primary">
                                        Clasificación de la cuenta <small className="text-danger">*</small>
                                    </label>
                                    <AsyncSelect
                                        isClearable
                                        value={data?.accountClassification}
                                        onFocus={() => {
                                            getAccountClassifications();
                                        }}
                                        defaultOptions={mapValues(accountClassifications)}
                                        isLoading={loadingAccountClassifications}
                                        loadOptions={(e) => handleLoadSelectOptions(e, getAccountClassifications)}
                                        placeholder='Escriba el nombre para buscar...'
                                        onChange={(e) => { handleChange({ target: { value: e, name: 'accountClassification' } }) }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="form-group">
                                    <label className="text-primary">
                                        Descripción
                                    </label>
                                    <textarea
                                        placeholder="Descripción de la cuenta..."
                                        className="form-control"
                                        value={data?.description}
                                        name="description"
                                        style={{ height: 100 }}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-3">
                        <h3 className="mb-3">
                            Permitir edición de la cuenta solo ha:
                        </h3>
                        <ul>
                            {
                                data?.users?.map((user, i) => {
                                    return (
                                        <li key={i} className="d-flex align-items-center gap-2 mb-2 border-bottom select-user" onClick={() => handleRemoveUser(i)}>
                                            <img src={`${user?.imagePath}`} style={{ width: 40, height: 40 }} className="rounded-circle" />
                                            <div>
                                                <p className="mb-0">
                                                    {user?.name}
                                                </p>
                                                <p className="mb-0">
                                                    {user?.documentNumber}
                                                </p>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        <button type="button" className="btn btn-primary w-100" onClick={(e) => setShowUsersModal(true)}>
                            Agregar usuario
                        </button>
                    </div>
                </div>

                <br />
                <div className="text-end">
                    <button className="btn btn-primary">
                        Actualizar
                    </button>
                </div>
            </form>
            <UsersAccountModal
                data={data}
                setData={setData}
                setShow={setShowUsersModal}
                show={showUsersModal}
            />
        </div >
    )
}

export default AccountsEdit;